import styled from '@emotion/styled';
import { X as Close } from 'lucide-react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import IconButton from '@mui/material/IconButton';
import { styled as newStyled } from '@mui/material/styles';
import SeverityIcons from '@root/components/SeverityIcons/SeverityIcons';
import CheckBox from '@root/components/v2/ui-elements/CheckBox';
import { useQueryClient } from '@tanstack/react-query';
import { Spinner } from 'react-bootstrap';

import Select from '@root/components/v2/ui-elements/Select';

// import { Spinner } from 'react-bootstrap';
// import './style.scss';
import agent from '@root/agent';
import useEnhancedQuery from '@root/query/useEnhancedQuery';
import { useCallback, useEffect, useMemo, useState } from 'react';
// import { SeverityWithText } from '@root/components/bootstrapTable/badges/severity';
import SelectNew from '@root/components/v2/ui-elements/Select/select-new';
import isEmpty from 'lodash/isEmpty';
import { toast } from 'sonner';
import { useSelector } from 'react-redux';

const BootstrapDialog = newStyled(Dialog)(() => ({
  '& .MuiDialogContent-root': {
    border: 'none',

    // padding: theme.spacing(2),
  },
  '& .MuiDialogActions-root': {
    // padding: theme.spacing(1),
  },
}));
const TextBox = styled.textarea`
  width: 100%;

  outline: none;

  border-radius: 5px;
  border: 1px solid var(--boder-line-light, #cbd5e0);
  background: var(--Others-White, #fff);
  padding: 12px 15px;
  height: 115px;

  color: var(--Secondary-200, #484d56);
  font-family: Manrope;
  font-size: 12px;
  font-weight: 500;
`;

function BootstrapDialogTitle(props) {
  const { children, onClose, ...other } = props;

  return (
    <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
      {children}
      {onClose ? (
        <IconButton
          onClick={onClose}
          sx={{
            width: '25px',
            height: '25px',
            background: 'var(--background)',
            border: '1px solid var(--border-color)',
          }}>
          <Close
            sx={{
              width: '15px',
              color: 'var(--text-color)',
            }}
          />
        </IconButton>
      ) : null}
    </DialogTitle>
  );
}

const createHierarchy = data => {
  const result = [];

  data.forEach(item => {
    const [first, second, third] = item.split('/');

    // Find or create the first-level object
    let firstLevel = result.find(obj => obj.value === first);
    if (!firstLevel) {
      firstLevel = {
        value: first,
        children: [],
        fullPath: first,
        original: item,
        rest: {
          rem1: second,
          rem2: third,
        },
        level: 1,
      };
      result.push(firstLevel);
    }

    // Find or create the second-level object
    let secondLevel = firstLevel.children.find(obj => obj.value === second);
    if (!secondLevel) {
      secondLevel = {
        value: second,
        children: [],
        fullPath: `${first}/${second}`,
        parent: firstLevel.value,
        original: item,
        rest: {
          rem1: first,
          rem2: third,
        },
        level: 2,
      };
      firstLevel.children.push(secondLevel);
    }

    // Add the third-level object
    let thirdLevel = {
      value: third,
      children: [],
      fullPath: `${first}/${second}/${third}`,
      parent: secondLevel.value,
      grandparent: firstLevel.value,
      original: item,
      rest: {
        rem1: first,
        rem2: second,
      },
      level: 3,
    };
    secondLevel.children.push(thirdLevel);
  });

  return result;
};

// Example usage:
// const data = ['A/B/C', 'A/B/D', 'A/E/F', 'X/Y/Z'];

// console.log(JSON.stringify(createHierarchy(data), null, 2));

const ActionModal = ({ onClose, open, selectedRow }) => {
  const [selectClusters, setSelectClusters] = useState([selectedRow.cluster_name]);
  const [selectWorkloads, setSelectWorkloads] = useState([]);
  const [selectNameSpace, setSelectNameSpace] = useState([]);
  const [selectContainer, setSelectContainer] = useState([]);
  const [justification, setJustification] = useState('');
  const [expiryDate, setExpiryDate] = useState('');
  const [checked, setChecked] = useState(false);
  const [isCreating, setIsCreating] = useState(false);
  const queryClient = useQueryClient();
  const user = useSelector(state => state.user);

  const { data: exceptionData, isFetching: isFetchingExceptionData } = useEnhancedQuery(
    ['get_kubernetes_exception_data', selectedRow],
    () =>
      agent.Kubernetes.get_exception({
        cve_id: selectedRow.cve_id,
        account_id: selectedRow.account_id,
        cluster: selectedRow.cluster,
      }),
  );

  // console.log(exceptionData, isFetchingExceptionData, 'isFetchingExceptionData');
  const generateOriginalValue = useCallback(obj => {
    const level = obj.level;
    const item1 = obj.rest.rem1;
    const item2 = obj.rest.rem2;

    if (level === 1) {
      return `${obj.value}/${item1}/${item2}`;
    } else if (level === 2) {
      return `${item1}/${obj.value}/${item2}`;
    } else {
      return `${item2}/${item1}/${obj.value}`;
    }
  }, []);
  useEffect(() => {
    if (isFetchingExceptionData || !exceptionData?.data) {
      return;
    }

    const alreadyCreatedExceptionData = createHierarchy(exceptionData?.data?.affected_workloads);

    const alreadySelectedNameSpaces = alreadyCreatedExceptionData?.map(item => {
      return {
        label: item.value,
        value: item.value,
        rest: item.rest,
        original: item.original,
        level: item.level,
        fullPath: item.fullPath,
      };
    });
    let alreadySelectedPods = [];
    let alreadySelectedContainers = [];
    for (let i = 0; i < alreadyCreatedExceptionData?.length; i++) {
      if (
        alreadySelectedNameSpaces?.some(
          item =>
            item.value === alreadyCreatedExceptionData[i].value &&
            generateOriginalValue(item) === alreadyCreatedExceptionData[i].original,
        )
      ) {
        alreadySelectedPods = alreadySelectedPods.concat(
          alreadyCreatedExceptionData[i]?.children?.map(item => {
            return {
              label: item.value,
              value: item.value,
              rest: item.rest,
              original: item.original,
              level: item.level,
              fullPath: item.fullPath,
              parent: item.parent,
            };
          }),
        );
      }
    }
    for (let i = 0; i < alreadyCreatedExceptionData.length; i++) {
      if (
        alreadySelectedNameSpaces?.some(
          item =>
            item.value === alreadyCreatedExceptionData[i].value &&
            generateOriginalValue(item) === alreadyCreatedExceptionData[i].original,
        )
      ) {
        for (let j = 0; j < alreadyCreatedExceptionData[i].children.length; j++) {
          if (
            alreadySelectedPods.some(
              ns =>
                ns.value === alreadyCreatedExceptionData[i].children[j].value &&
                generateOriginalValue(ns) === alreadyCreatedExceptionData[i].children[j].original,
            )
          ) {
            alreadySelectedContainers = alreadySelectedContainers.concat(
              alreadyCreatedExceptionData[i].children[j].children?.map(item => {
                return {
                  label: item.value,
                  value: item.value,
                  rest: item.rest,
                  original: item.original,
                  level: item.level,
                  parent: item.parent,
                  fullPath: item.fullPath,
                  grandparent: item.grandparent,
                };
              }),
            );
          }
        }
      }
    }

    setSelectWorkloads(() => {
      return alreadySelectedNameSpaces;
    });
    setSelectNameSpace(() => {
      return alreadySelectedPods;
    });
    setSelectContainer(() => {
      return alreadySelectedContainers;
    });
  }, [exceptionData?.data, generateOriginalValue, isFetchingExceptionData]);

  // console.log(typeof expiryDate, 'expiryDateexpiryDate');

  // console.log(selectedRow, 'selectedRowselectedRow');
  const globalData = createHierarchy(selectedRow?.affected_workloads);

  const workloadList = useMemo(() => {
    return globalData?.map(item => {
      return {
        label: item.value,
        value: item.value,
        rest: item.rest,
        original: item.original,
        level: item.level,
        fullPath: item.fullPath,
      };
    });
  }, [globalData]);
  // console.log(selectWorkloads, 'selectWorkloads');

  const namespaceList = useMemo(() => {
    let res = [];
    for (let i = 0; i < globalData?.length; i++) {
      if (
        selectWorkloads?.some(item => item.value === globalData[i].value && item.fullPath === globalData[i].fullPath)
      ) {
        res = res.concat(
          globalData[i]?.children?.map(item => {
            return {
              label: item.value,
              value: item.value,
              rest: item.rest,
              original: item.original,
              fullPath: item.fullPath,
              level: item.level,
              parent: item.parent,
            };
          }),
        );
      }
    }
    return res;
  }, [globalData, selectWorkloads]);
  // console.log(selectNameSpace, 'selectNameSpace');

  const containerList = useMemo(() => {
    let res = [];
    for (let i = 0; i < globalData.length; i++) {
      if (
        selectWorkloads?.some(item => item.value === globalData[i].value && item.fullPath === globalData[i].fullPath)
      ) {
        for (let j = 0; j < globalData[i].children.length; j++) {
          if (
            selectNameSpace.some(
              ns => ns.value === globalData[i].children[j].value && ns.fullPath === globalData[i].children[j].fullPath,
            )
          ) {
            res = res.concat(
              globalData[i].children[j].children?.map(item => {
                return {
                  label: item.value,
                  value: item.value,
                  rest: item.rest,
                  original: item.original,
                  fullPath: item.fullPath,
                  level: item.level,
                  parent: item.parent,
                  grandparent: item.grandparent,
                };
              }),
            );
          }
        }
      }
    }
    return res;
  }, [globalData, selectNameSpace, selectWorkloads]);

  const workloadPayloadList = useMemo(() => {
    let res = [];
    for (let i = 0; i < selectContainer.length; i++) {
      res.push(selectContainer[i].original);
    }
    return res;
  }, [selectContainer]);

  const handleClusterChange = useCallback(regions => {
    setSelectClusters(regions);
  }, []);

  const handleWorkloadChange = useCallback(
    value => {
      setSelectWorkloads(value);
    },
    [setSelectWorkloads],
  );
  const handleNamespaceChange = useCallback(value => {
    setSelectNameSpace(value);
  }, []);

  const handleContainerChange = useCallback(value => {
    setSelectContainer(value);
  }, []);

  const handleOnCheck = useCallback(() => {
    setChecked(prev => !prev);
  }, []);

  const handleDateChange = e => {
    setExpiryDate(e.target.value);
  };
  const handleCreateException = useCallback(async () => {
    setIsCreating(true);
    try {
      const res = await agent.Kubernetes.create_exception({
        // scan_type: 'OnDemand',
        account_id: selectedRow.account_id,
        cluster: selectedRow.cluster,
        cve_id: selectedRow.cve_id,
        workloads: workloadPayloadList,
        expiry: expiryDate,
        total_workloads: selectedRow?.affected_workloads ?? [],
        fix: checked,
        reason: justification,
        accepted_by: user?.info?.user?.email,
        severity: selectedRow.severity,
      });
      if (res && res?.error === 0) {
        toast.success(
          exceptionData?.data !== null ? 'Exception updated successfully' : 'Exception created successfully',
        );
      } else {
        toast.error('Something went wrong');
      }
    } catch (err) {
      toast.error('Something went wrong');
    } finally {
      setIsCreating(false);
      onClose();
      queryClient.invalidateQueries(['get_kubernetes_risk_acceptance_list']);
      queryClient.invalidateQueries(['get_vulnerability_datak8']);
    }
  }, [
    checked,
    exceptionData?.data,
    expiryDate,
    justification,
    onClose,
    queryClient,
    selectedRow.account_id,
    selectedRow?.affected_workloads,
    selectedRow.cluster,
    selectedRow.cve_id,
    selectedRow.severity,
    user?.info?.user?.email,
    workloadPayloadList,
  ]);
  // console.log(selectClusters, clusterList, 'clusterListclusterList');

  return (
    <div>
      {' '}
      <BootstrapDialog
        onClose={onClose}
        aria-labelledby="customized-dialog-title"
        open={open}
        className="DS__scan-modal"
        sx={{
          '& .MuiDialog-paper': {
            minWidth: '1000px',
            boxShadow: 'none',
            // height: '780px', // Replace with your desired width
          },
          // '.css-yiavyu-MuiBackdrop-root-MuiDialog-backdrop': {
          //   backgroundColor: 'rgba(0,0,0,0.05)',
          // },
          //   '& .MuiDialog-paper': {
          //   background: 'var(--background-color)',
          //   borderRadius: 'var(--border-radius)',
          //   boxShadow: 'var(--box-shadow)',

          //   color: 'var(--text-color)',
          // },
          // '& .MuiDialog-container': {
          //   background: 'transparent',
          // },
        }}>
        <BootstrapDialogTitle
          id="customized-dialog-title"
          onClose={onClose}
          sx={{ display: 'flex', justifyContent: 'space-between', padding: '30px', paddingBottom: '15px' }}>
          <span
            className="heading"
            style={{ marginBottom: '0', fontFamily: 'Manrope', fontWeight: 700, fontSize: '16px', lineHeight: 1.5 }}>
            Accepting the Risk
          </span>
        </BootstrapDialogTitle>
        <DialogContent dividers sx={{ padding: '0px' }}>
          <div
            style={{
              display: 'flex',
              padding: '15px 30px',
              gap: '4px',
              alignItems: 'center',
              paddingBottom: '0px !important',
            }}>
            <span>
              <SeverityIcons severity={selectedRow.severity} />
            </span>
            <p className="input-heading m-0" style={{ paddingBottom: '0px' }}>
              {' '}
              {selectedRow.cve_id}
            </p>
          </div>
          <div style={{ display: 'flex', padding: '15px', paddingTop: '0px' }}>
            <div style={{ padding: '15px' }}>
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  gap: '15px',
                }}>
                <div>
                  <p className="input-heading m-0"> Cluster</p>
                  <Select
                    width="414px"
                    height="40px"
                    placeholder={`${selectedRow.cluster}`}
                    options={[]}
                    disabled={true}
                    value={selectClusters}
                    //   regionDropdown={true}
                    onChange={v => handleClusterChange(v)}
                  />
                </div>
                <div>
                  <p className="input-heading m-0">
                    {' '}
                    Namespace <span style={{ color: 'red' }}>*</span>
                  </p>
                  <SelectNew
                    width="414px"
                    height="40px"
                    placeholder="Choose namespaces"
                    options={workloadList}
                    value={selectWorkloads}
                    //   regionDropdown={true}
                    onChange={v => handleWorkloadChange(v)}
                  />
                </div>{' '}
                <div>
                  <p className="input-heading m-0">
                    {' '}
                    Pod <span style={{ color: 'red' }}>*</span>{' '}
                  </p>
                  <SelectNew
                    width="414px"
                    height="40px"
                    disabled={selectWorkloads?.length === 0}
                    placeholder="Choose pods"
                    options={namespaceList}
                    value={selectNameSpace}
                    isLabelTagging={true}
                    //   regionDropdown={true}
                    onChange={v => handleNamespaceChange(v)}
                  />
                </div>
                <div>
                  <p className="input-heading m-0">
                    {' '}
                    Container <span style={{ color: 'red' }}>*</span>
                  </p>
                  <SelectNew
                    width="414px"
                    height="40px"
                    disabled={selectWorkloads?.length === 0 || selectNameSpace?.length === 0}
                    placeholder="Choose containers"
                    options={containerList}
                    isLabelTagging={true}
                    isGrandParent={true}
                    value={selectContainer}
                    //   regionDropdown={true}
                    onChange={v => handleContainerChange(v)}
                  />
                </div>
              </div>
            </div>
            <div style={{ padding: '15px', width: '100%' }}>
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  gap: '15px',
                }}>
                <div style={{ width: '100%' }}>
                  <p className="input-heading m-0"> Justification</p>
                  <TextBox
                    placeholder="Enter the justification"
                    onChange={e => setJustification(e.target.value)}
                    autoFocus>
                    {justification}
                  </TextBox>
                </div>
                <div>
                  <p className="input-heading m-0"> Expiration</p>
                  <input
                    className="input"
                    type="date"
                    style={{ width: '100%', height: '40px', marginBottom: '15px' }}
                    value={expiryDate}
                    placeholder="MM/DD/YYYY"
                    onChange={handleDateChange}
                  />
                </div>
                <div onClick={handleOnCheck} style={{ display: 'flex', alignItems: 'center' }}>
                  <CheckBox checked={checked} /> <span className=" m-0"> Until fix is available</span>
                </div>
                {/* <div className="assesment-type">
                    <p className="input-heading m-0"> Connection Method</p>
                  </div> */}
              </div>
            </div>
          </div>
          <div
            style={{
              display: 'flex',
              flexWrap: 'nowrap',
              justifyContent: 'end',
              gap: '10px',
              padding: '30px',
              // borderTop: '1px solid #D1D2D5',
            }}>
            <Button
              // color="primary"

              variant={'outline'}
              className="text-[#1a202c]"
              onClick={onClose}>
              Cancel
            </Button>
            <Button
              onClick={handleCreateException}
              // color="primary"
              disabled={isEmpty(selectContainer) || isEmpty(selectNameSpace) || isEmpty(selectWorkloads)}>
              {isCreating ? <Spinner animation="border" size="sm" /> : null}
              {isCreating ? 'Saving' : 'Save'}
              {/* Save */}
            </Button>
          </div>
        </DialogContent>
      </BootstrapDialog>
    </div>
  );
};

export default ActionModal;
